import { gql } from '@apollo/client';

export const UPDATE_FM_SP_FIELD_VALUE = gql`
  mutation UpdateFmSpFieldValue($values: [FmSpFieldValueInput!]!, $organization_id: Int!) {
    updateFmSpFieldValue(values: $values, organization_id: $organization_id) {
      field_id
    }
  }
`;
